import type { FC } from "react";

import type { EnrichedTicketNode } from "./ExecutionFlowGraph";

import {
  AccentCard,
  CARD_DESC_CLASS,
  CARD_META_CLASS,
  CARD_STATUS_CLASS,
  CARD_TITLE_CLASS,
  StatusDot,
  getStatusAccent,
  getStatusDot,
  isActiveStatus,
} from "../common";

interface TicketCardProps {
  enrichedNode: EnrichedTicketNode;
  onClick: () => void;
}

export const TicketCard: FC<TicketCardProps> = ({ enrichedNode, onClick }) => {
  const { node: ticket, dependencyIds, blockedByThisIds } = enrichedNode;

  return (
    <AccentCard accent={getStatusAccent(ticket.status)} onClick={onClick}>
      <div className="flex items-center gap-1.5">
        <StatusDot
          color={getStatusDot(ticket.status)}
          pulse={isActiveStatus(ticket.status)}
        />
        <span className={CARD_TITLE_CLASS}>
          {ticket.plan_item_id || ticket.ticket_id}
        </span>
        <span className={CARD_STATUS_CLASS}>{ticket.status}</span>
      </div>
      {ticket.summary && (
        <p className={CARD_DESC_CLASS} title={ticket.summary}>
          {ticket.summary}
        </p>
      )}
      {(dependencyIds.length > 0 || blockedByThisIds.length > 0) && (
        <div
          className={`mt-0.5 flex items-center gap-2 pl-3 ${CARD_META_CLASS}`}
        >
          {dependencyIds.length > 0 && (
            <span title={`Depends on: ${dependencyIds.join(", ")}`}>
              {dependencyIds.length} dep
              {dependencyIds.length !== 1 && "s"}
            </span>
          )}
          {blockedByThisIds.length > 0 && (
            <span title={`Blocks: ${blockedByThisIds.join(", ")}`}>
              blocks {blockedByThisIds.length}
            </span>
          )}
        </div>
      )}
    </AccentCard>
  );
};
